var endpointMap = {
	ar: {
		open_registration: "translation-ar.json",
		"pages.dspActivationActivate": "translation-ar.json",
		"pages.dspActivationRequest": "translation-ar.json",
		"pages.managerAccountRegistration": "translation-ar.json",
		"pages.marketplaceExpansion": "translation-ar.json",
		"pages.terms": "translation-ar.json",
		strings: "translation-ar.json"
	},
	"ar-AE": {
		open_registration: "translation-ar.json",
		"pages.dspActivationActivate": "translation-ar.json",
		"pages.dspActivationRequest": "translation-ar.json",
		"pages.managerAccountRegistration": "translation-ar.json",
		"pages.marketplaceExpansion": "translation-ar.json",
		"pages.terms": "translation-ar.json",
		strings: "translation-ar.json"
	},
	de: {
		open_registration: "translation-de.json",
		"pages.dspActivationActivate": "translation-de.json",
		"pages.dspActivationRequest": "translation-de.json",
		"pages.managerAccountRegistration": "translation-de.json",
		"pages.marketplaceExpansion": "translation-de.json",
		"pages.terms": "translation-de.json",
		strings: "translation-de.json"
	},
	"de-DE": {
		open_registration: "translation-de.json",
		"pages.dspActivationActivate": "translation-de.json",
		"pages.dspActivationRequest": "translation-de.json",
		"pages.managerAccountRegistration": "translation-de.json",
		"pages.marketplaceExpansion": "translation-de.json",
		"pages.terms": "translation-de.json",
		strings: "translation-de.json"
	},
	en: {
		open_registration: "translation-en.json",
		"pages.dspActivationActivate": "translation-en.json",
		"pages.dspActivationRequest": "translation-en.json",
		"pages.managerAccountRegistration": "translation-en.json",
		"pages.marketplaceExpansion": "translation-en.json",
		"pages.terms": "translation-en.json",
		strings: "translation-en.json"
	},
	"en-AU": {
		open_registration: "translation-en.json",
		"pages.dspActivationActivate": "translation-en.json",
		"pages.dspActivationRequest": "translation-en.json",
		"pages.managerAccountRegistration": "translation-en.json",
		"pages.marketplaceExpansion": "translation-en.json",
		"pages.terms": "translation-en.json",
		strings: "translation-en.json"
	},
	"en-CA": {
		open_registration: "translation-en.json",
		"pages.dspActivationActivate": "translation-en.json",
		"pages.dspActivationRequest": "translation-en.json",
		"pages.managerAccountRegistration": "translation-en.json",
		"pages.marketplaceExpansion": "translation-en.json",
		"pages.terms": "translation-en.json",
		strings: "translation-en.json"
	},
	"en-GB": {
		open_registration: "translation-en.json",
		"pages.dspActivationActivate": "translation-en.json",
		"pages.dspActivationRequest": "translation-en.json",
		"pages.managerAccountRegistration": "translation-en.json",
		"pages.marketplaceExpansion": "translation-en.json",
		"pages.terms": "translation-en.json",
		strings: "translation-en.json"
	},
	"en-IN": {
		open_registration: "translation-en.json",
		"pages.dspActivationActivate": "translation-en.json",
		"pages.dspActivationRequest": "translation-en.json",
		"pages.managerAccountRegistration": "translation-en.json",
		"pages.marketplaceExpansion": "translation-en.json",
		"pages.terms": "translation-en.json",
		strings: "translation-en.json"
	},
	"en-SG": {
		open_registration: "translation-en.json",
		"pages.dspActivationActivate": "translation-en.json",
		"pages.dspActivationRequest": "translation-en.json",
		"pages.managerAccountRegistration": "translation-en.json",
		"pages.marketplaceExpansion": "translation-en.json",
		"pages.terms": "translation-en.json",
		strings: "translation-en.json"
	},
	"en-US": {
		open_registration: "translation-en.json",
		"pages.dspActivationActivate": "translation-en.json",
		"pages.dspActivationRequest": "translation-en.json",
		"pages.managerAccountRegistration": "translation-en.json",
		"pages.marketplaceExpansion": "translation-en.json",
		"pages.terms": "translation-en.json",
		strings: "translation-en.json"
	},
	es: {
		open_registration: "translation-es.json",
		"pages.dspActivationActivate": "translation-es.json",
		"pages.dspActivationRequest": "translation-es.json",
		"pages.managerAccountRegistration": "translation-es.json",
		"pages.marketplaceExpansion": "translation-es.json",
		"pages.terms": "translation-es.json",
		strings: "translation-es.json"
	},
	"es-CO": {
		open_registration: "translation-es.json",
		"pages.dspActivationActivate": "translation-es.json",
		"pages.dspActivationRequest": "translation-es.json",
		"pages.managerAccountRegistration": "translation-es.json",
		"pages.marketplaceExpansion": "translation-es.json",
		"pages.terms": "translation-es.json",
		strings: "translation-es.json"
	},
	"es-ES": {
		open_registration: "translation-es.json",
		"pages.dspActivationActivate": "translation-es.json",
		"pages.dspActivationRequest": "translation-es.json",
		"pages.managerAccountRegistration": "translation-es.json",
		"pages.marketplaceExpansion": "translation-es.json",
		"pages.terms": "translation-es.json",
		strings: "translation-es.json"
	},
	"es-MX": {
		open_registration: "translation-es.json",
		"pages.dspActivationActivate": "translation-es.json",
		"pages.dspActivationRequest": "translation-es.json",
		"pages.managerAccountRegistration": "translation-es.json",
		"pages.marketplaceExpansion": "translation-es.json",
		"pages.terms": "translation-es.json",
		strings: "translation-es.json"
	},
	fr: {
		open_registration: "translation-fr.json",
		"pages.dspActivationActivate": "translation-fr.json",
		"pages.dspActivationRequest": "translation-fr.json",
		"pages.managerAccountRegistration": "translation-fr.json",
		"pages.marketplaceExpansion": "translation-fr.json",
		"pages.terms": "translation-fr.json",
		strings: "translation-fr.json"
	},
	"fr-CA": {
		open_registration: "translation-fr.json",
		"pages.dspActivationActivate": "translation-fr.json",
		"pages.dspActivationRequest": "translation-fr.json",
		"pages.managerAccountRegistration": "translation-fr.json",
		"pages.marketplaceExpansion": "translation-fr.json",
		"pages.terms": "translation-fr.json",
		strings: "translation-fr.json"
	},
	"fr-FR": {
		open_registration: "translation-fr.json",
		"pages.dspActivationActivate": "translation-fr.json",
		"pages.dspActivationRequest": "translation-fr.json",
		"pages.managerAccountRegistration": "translation-fr.json",
		"pages.marketplaceExpansion": "translation-fr.json",
		"pages.terms": "translation-fr.json",
		strings: "translation-fr.json"
	},
	hi: {
		open_registration: "translation-hi.json",
		"pages.dspActivationActivate": "translation-hi.json",
		"pages.dspActivationRequest": "translation-hi.json",
		"pages.managerAccountRegistration": "translation-hi.json",
		"pages.marketplaceExpansion": "translation-hi.json",
		"pages.terms": "translation-hi.json",
		strings: "translation-hi.json"
	},
	"hi-IN": {
		open_registration: "translation-hi.json",
		"pages.dspActivationActivate": "translation-hi.json",
		"pages.dspActivationRequest": "translation-hi.json",
		"pages.managerAccountRegistration": "translation-hi.json",
		"pages.marketplaceExpansion": "translation-hi.json",
		"pages.terms": "translation-hi.json",
		strings: "translation-hi.json"
	},
	it: {
		open_registration: "translation-it.json",
		"pages.dspActivationActivate": "translation-it.json",
		"pages.dspActivationRequest": "translation-it.json",
		"pages.managerAccountRegistration": "translation-it.json",
		"pages.marketplaceExpansion": "translation-it.json",
		"pages.terms": "translation-it.json",
		strings: "translation-it.json"
	},
	"it-IT": {
		open_registration: "translation-it.json",
		"pages.dspActivationActivate": "translation-it.json",
		"pages.dspActivationRequest": "translation-it.json",
		"pages.managerAccountRegistration": "translation-it.json",
		"pages.marketplaceExpansion": "translation-it.json",
		"pages.terms": "translation-it.json",
		strings: "translation-it.json"
	},
	ja: {
		open_registration: "translation-ja.json",
		"pages.dspActivationActivate": "translation-ja.json",
		"pages.dspActivationRequest": "translation-ja.json",
		"pages.managerAccountRegistration": "translation-ja.json",
		"pages.marketplaceExpansion": "translation-ja.json",
		"pages.terms": "translation-ja.json",
		strings: "translation-ja.json"
	},
	"ja-JP": {
		open_registration: "translation-ja.json",
		"pages.dspActivationActivate": "translation-ja.json",
		"pages.dspActivationRequest": "translation-ja.json",
		"pages.managerAccountRegistration": "translation-ja.json",
		"pages.marketplaceExpansion": "translation-ja.json",
		"pages.terms": "translation-ja.json",
		strings: "translation-ja.json"
	},
	ko: {
		open_registration: "translation-ko.json",
		"pages.dspActivationActivate": "translation-ko.json",
		"pages.dspActivationRequest": "translation-ko.json",
		"pages.managerAccountRegistration": "translation-ko.json",
		"pages.marketplaceExpansion": "translation-ko.json",
		"pages.terms": "translation-ko.json",
		strings: "translation-ko.json"
	},
	"ko-KR": {
		open_registration: "translation-ko.json",
		"pages.dspActivationActivate": "translation-ko.json",
		"pages.dspActivationRequest": "translation-ko.json",
		"pages.managerAccountRegistration": "translation-ko.json",
		"pages.marketplaceExpansion": "translation-ko.json",
		"pages.terms": "translation-ko.json",
		strings: "translation-ko.json"
	},
	nl: {
		open_registration: "translation-nl.json",
		"pages.dspActivationActivate": "translation-nl.json",
		"pages.dspActivationRequest": "translation-nl.json",
		"pages.managerAccountRegistration": "translation-nl.json",
		"pages.marketplaceExpansion": "translation-nl.json",
		"pages.terms": "translation-nl.json",
		strings: "translation-nl.json"
	},
	"nl-NL": {
		open_registration: "translation-nl.json",
		"pages.dspActivationActivate": "translation-nl.json",
		"pages.dspActivationRequest": "translation-nl.json",
		"pages.managerAccountRegistration": "translation-nl.json",
		"pages.marketplaceExpansion": "translation-nl.json",
		"pages.terms": "translation-nl.json",
		strings: "translation-nl.json"
	},
	pl: {
		open_registration: "translation-pl.json",
		"pages.dspActivationActivate": "translation-pl.json",
		"pages.dspActivationRequest": "translation-pl.json",
		"pages.managerAccountRegistration": "translation-pl.json",
		"pages.marketplaceExpansion": "translation-pl.json",
		"pages.terms": "translation-pl.json",
		strings: "translation-pl.json"
	},
	"pl-PL": {
		open_registration: "translation-pl.json",
		"pages.dspActivationActivate": "translation-pl.json",
		"pages.dspActivationRequest": "translation-pl.json",
		"pages.managerAccountRegistration": "translation-pl.json",
		"pages.marketplaceExpansion": "translation-pl.json",
		"pages.terms": "translation-pl.json",
		strings: "translation-pl.json"
	},
	pt: {
		open_registration: "translation-pt.json",
		"pages.dspActivationActivate": "translation-pt.json",
		"pages.dspActivationRequest": "translation-pt.json",
		"pages.managerAccountRegistration": "translation-pt.json",
		"pages.marketplaceExpansion": "translation-pt.json",
		"pages.terms": "translation-pt.json",
		strings: "translation-pt.json"
	},
	"pt-BR": {
		open_registration: "translation-pt.json",
		"pages.dspActivationActivate": "translation-pt.json",
		"pages.dspActivationRequest": "translation-pt.json",
		"pages.managerAccountRegistration": "translation-pt.json",
		"pages.marketplaceExpansion": "translation-pt.json",
		"pages.terms": "translation-pt.json",
		strings: "translation-pt.json"
	},
	sv: {
		open_registration: "translation-sv.json",
		"pages.dspActivationActivate": "translation-sv.json",
		"pages.dspActivationRequest": "translation-sv.json",
		"pages.managerAccountRegistration": "translation-sv.json",
		"pages.marketplaceExpansion": "translation-sv.json",
		"pages.terms": "translation-sv.json",
		strings: "translation-sv.json"
	},
	"sv-SE": {
		open_registration: "translation-sv.json",
		"pages.dspActivationActivate": "translation-sv.json",
		"pages.dspActivationRequest": "translation-sv.json",
		"pages.managerAccountRegistration": "translation-sv.json",
		"pages.marketplaceExpansion": "translation-sv.json",
		"pages.terms": "translation-sv.json",
		strings: "translation-sv.json"
	},
	ta: {
		open_registration: "translation-ta.json",
		"pages.dspActivationActivate": "translation-ta.json",
		"pages.dspActivationRequest": "translation-ta.json",
		"pages.managerAccountRegistration": "translation-ta.json",
		"pages.marketplaceExpansion": "translation-ta.json",
		"pages.terms": "translation-ta.json",
		strings: "translation-ta.json"
	},
	"ta-IN": {
		open_registration: "translation-ta.json",
		"pages.dspActivationActivate": "translation-ta.json",
		"pages.dspActivationRequest": "translation-ta.json",
		"pages.managerAccountRegistration": "translation-ta.json",
		"pages.marketplaceExpansion": "translation-ta.json",
		"pages.terms": "translation-ta.json",
		strings: "translation-ta.json"
	},
	th: {
		open_registration: "translation-th.json",
		"pages.dspActivationActivate": "translation-th.json",
		"pages.dspActivationRequest": "translation-th.json",
		"pages.managerAccountRegistration": "translation-th.json",
		"pages.marketplaceExpansion": "translation-th.json",
		"pages.terms": "translation-th.json",
		strings: "translation-th.json"
	},
	"th-TH": {
		open_registration: "translation-th.json",
		"pages.dspActivationActivate": "translation-th.json",
		"pages.dspActivationRequest": "translation-th.json",
		"pages.managerAccountRegistration": "translation-th.json",
		"pages.marketplaceExpansion": "translation-th.json",
		"pages.terms": "translation-th.json",
		strings: "translation-th.json"
	},
	tr: {
		open_registration: "translation-tr.json",
		"pages.dspActivationActivate": "translation-tr.json",
		"pages.dspActivationRequest": "translation-tr.json",
		"pages.managerAccountRegistration": "translation-tr.json",
		"pages.marketplaceExpansion": "translation-tr.json",
		"pages.terms": "translation-tr.json",
		strings: "translation-tr.json"
	},
	"tr-TR": {
		open_registration: "translation-tr.json",
		"pages.dspActivationActivate": "translation-tr.json",
		"pages.dspActivationRequest": "translation-tr.json",
		"pages.managerAccountRegistration": "translation-tr.json",
		"pages.marketplaceExpansion": "translation-tr.json",
		"pages.terms": "translation-tr.json",
		strings: "translation-tr.json"
	},
	und: {
		open_registration: "translation.json",
		"pages.dspActivationActivate": "translation.json",
		"pages.dspActivationRequest": "translation.json",
		"pages.managerAccountRegistration": "translation.json",
		"pages.marketplaceExpansion": "translation.json",
		"pages.terms": "translation.json",
		strings: "translation.json"
	},
	vi: {
		open_registration: "translation-vi.json",
		"pages.dspActivationActivate": "translation-vi.json",
		"pages.dspActivationRequest": "translation-vi.json",
		"pages.managerAccountRegistration": "translation-vi.json",
		"pages.marketplaceExpansion": "translation-vi.json",
		"pages.terms": "translation-vi.json",
		strings: "translation-vi.json"
	},
	"vi-VN": {
		open_registration: "translation-vi.json",
		"pages.dspActivationActivate": "translation-vi.json",
		"pages.dspActivationRequest": "translation-vi.json",
		"pages.managerAccountRegistration": "translation-vi.json",
		"pages.marketplaceExpansion": "translation-vi.json",
		"pages.terms": "translation-vi.json",
		strings: "translation-vi.json"
	},
	zh: {
		open_registration: "translation-zh.json",
		"pages.dspActivationActivate": "translation-zh.json",
		"pages.dspActivationRequest": "translation-zh.json",
		"pages.managerAccountRegistration": "translation-zh.json",
		"pages.marketplaceExpansion": "translation-zh.json",
		"pages.terms": "translation-zh.json",
		strings: "translation-zh.json"
	},
	"zh-CN": {
		open_registration: "translation-zh.json",
		"pages.dspActivationActivate": "translation-zh.json",
		"pages.dspActivationRequest": "translation-zh.json",
		"pages.managerAccountRegistration": "translation-zh.json",
		"pages.marketplaceExpansion": "translation-zh.json",
		"pages.terms": "translation-zh.json",
		strings: "translation-zh.json"
	},
	"zh-TW": {
		open_registration: "translation-zh.json",
		"pages.dspActivationActivate": "translation-zh.json",
		"pages.dspActivationRequest": "translation-zh.json",
		"pages.managerAccountRegistration": "translation-zh.json",
		"pages.marketplaceExpansion": "translation-zh.json",
		"pages.terms": "translation-zh.json",
		strings: "translation-zh.json"
	}
};
var arbManifest = {
	endpointMap: endpointMap
};

export { arbManifest as default, endpointMap };
